require('./bootstrap')
import Vue from 'vue'
import ElementUI from 'element-ui'
import './../css/element-variables.scss'
import VueRouter from 'vue-router'
import Spinner from './helpers/Spinner'
import ServerError from './pages/ServerError'
import Storage from './helpers/Storage'
import locale from 'element-ui/lib/locale/lang/en'
import store from './store'
import Editor from '@morioh/v-quill-editor'

Vue.use(Editor);
Vue.use(ElementUI, {locale})

// Setup Router
Vue.use(VueRouter)
const routes = [
  {path: '/', redirect: '/login'},
  {
    path     : '/login',
    component: () => import(/* webpackChunkName: "login" */'./pages/Login'),
  },
  {
    path     : '/pages',
    name     : 'pages',
    component: () => import(/* webpackChunkName: "app0layout" */'./pages/AppLayout'),
    children : [
      {
        path     : 'dashboard',
        name     : 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */'./pages/Dashboard'),
      },
      {
        path     : 'courses',
        name     : 'course-list',
        component: () => import(/* webpackChunkName: "courses" */'./pages/Courses'),
      },
      {
        path     : 'sync',
        name     : 'sync',
        component: () => import(/* webpackChunkName: "sync-courses" */'./pages/SyncCourses'),
      },
      {
        path     : 'course',
        name     : 'new-course',
        component: () => import(/* webpackChunkName: "new-course" */'./pages/Course'),
      },
      {
        path     : 'course/:id',
        component: () => import(/* webpackChunkName: "update-course" */'./pages/Course'),
      },
      {
        path     : 'course/:course_uid/configuration',
        name     : 'configuration',
        component: () => import(/* webpackChunkName: "update-course" */'./pages/Configuration'),
      },
      {
        path     : 'courses/:course_uid/cases',
        name     : 'course-case-list',
        component: () => import(/* webpackChunkName: "cases" */'./pages/Cases'),
      },
      {
        path     : 'courses/:course_uid/new-case',
        name     : 'new-case',
        component: () => import(/* webpackChunkName: "cases" */'./pages/NewCase'),
      },
      {
        path     : 'courses/:course_uid/cases/:case_id',
        name     : 'edit-case',
        props    : true,
        component: () => import(/* webpackChunkName: "cases" */'./pages/NewCase'),
      },
      {
        path     : 'courses/:course_uid/cases/:case_id/markup',
        name     : 'markup-tool',
        props    : true,
        component: () => import(/* webpackChunkName: "markup-tool" */'./pages/MarkupWrapper'),
      },
      {
        path     : '404',
        name     : 'not found',
        component: () => import(/* webpackChunkName: "not-found" */'./pages/NotFound'),
      },
      {path: '/500', name: 'server error', component: ServerError},

    ],
  },
  {
    path     : '*',
    component: () => import(/* webpackChunkName: "not-found" */'./pages/NotFound'),
  },

]

let fullRoutes = routes.map(route => {
  route.loading = Spinner
  route.error   = ServerError
  return route
})
console.log(process.env)
const router = new VueRouter({
  mode           : 'history',
  routes         : fullRoutes,
  linkActiveClass: 'border-cyan-500 border-b-3 text-gray-900 font-medium text-cyan-700',
})

let shouldCheckStatus = true
/**
 * Make sure the user is notified when they are logged out.
 *
 * @type {boolean}
 */

window.loggedOut = false
window.axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  console.error(error.response ? error.response.status : error)
  if (window.loggedOut === false && error.response && error.response.status === 401 && ['/', '/login'].includes(window.location.pathname) === false) {
    window.loggedOut = true
    Storage.remove('imagesim_markup_tool_token')
    alert('You have been signed out. Refresh the page to sign in.')
    return router.push('/login')
  }
  return Promise.reject(error)
})

setTimeout(() => {
  if (Storage.get('imagesim_markup_tool_token')) {
    window.axios.post('/auth/refresh').then(response => {
      let status = response.data
      if (!status.access_token) {
        return router.push('/login')
      }
      Storage.set('imagesim_markup_tool_token', status.access_token)
    }).catch(error => {
      console.error(`Error: server error ${error.response && error.response.status}`)
    })
  }

}, 1000 * 60 * 15) //15 minutes


// Check user logged_in status before every page change or load.
if (['/', '/login'].includes(window.location.pathname) === false && Storage.get('imagesim_markup_tool_token')) {
  router.beforeEach((to, from, next) => {
    if (shouldCheckStatus) {
      shouldCheckStatus = false
      setTimeout(() => {
        shouldCheckStatus = true
      }, 1000 * 60 * 20) // 20 minutes

      window.axios.get('/auth/me').then(response => {
        let data = response.data
        if (!data.email) {
          return router.push('/login')
        } else {
          next()
        }
      }).catch(error => {
        next()
        console.error(`Error: server error ${error.response && error.response.status}`)
      })
    } else {
      next()
    }
  })
}

Vue.filter('plural', (value, singular, plural, hide_value) => {
  if (value === 0 || value > 1) {
    return `${hide_value ? '' : `${value} `}${plural}`
  }

  return `${hide_value ? '' : `${value} `}${singular}`
})

// Mount the app
new Vue({
  router,
  store,
}).$mount('#app')

// new Vue({
//   el: '#app',
//   render: h => h(App)
// });
